import { Col, Row } from "antd";
import { UNITS } from "../../../Common/Constants";
import { useState } from "react";
import SPEED from "../../../../assets/images/icons/speed.svg";
import { TEST_RIDE_CUMULATIVE } from "../../../Common/Grafana/Constants";
import panelList from "../panelList.json";
import CardCollapse from "../../../Common/CardCollapse";
import ChartFilter from "../../../Common/ChartFilter";
import PanelsRow from "../../../Common/Grafana/PanelsRow";

const SpeedAnalytics = ({
  tripSummary,
  summaryList,
  baseUrl,
  baseFilterObject,
  data,
}) => {
  const summaryCount = summaryList?.length;
  const [chartType, setChartType] = useState({
    histogram: true,
    boxPlot: false,
  });

  const updateChartType = (name, value) => {
    setChartType((prev) => ({ ...prev, [name]: value }));
  };

  const subContent = (
    <>
      <Row gutter={[16, 16]} justify="end" className="mt05">
        <Col
          xs={summaryCount >= 2 ? 6 : 6}
          sm={summaryCount >= 2 ? 6 : 6}
          md={summaryCount >= 2 ? 6 : 3}
          lg={summaryCount >= 2 ? 6 : 3}
          xl={summaryCount >= 2 ? 6 : 3}
        >
          <ChartFilter
            updateChartType={updateChartType}
            chartType={chartType}
            chartToHide={"timeSeries"}
          />
        </Col>
      </Row>
      <div className="grey-box mt1">
        <Row gutter={[16, 16]} justify="center">
          <Col
            xs={24}
            sm={12}
            md={summaryCount >= 2 ? 24 : 12}
            lg={summaryCount >= 2 ? 12 : 6}
            xl={summaryCount >= 2 ? 12 : 6}
          >
            Average:
            {(parseFloat(tripSummary?.averageSpeed) || parseFloat(tripSummary?.averageSpeed) === 0) ? (
              <>
                <span className="ml025 bold">
                  {parseFloat(tripSummary?.averageSpeed)?.toFixed(2)}
                </span>
                <span className="ml025">{UNITS.KM_PER_HR}</span>
              </>
            ) : (
              <span className="disabled ml025">NA</span>
            )}
          </Col>
          <Col
            xs={24}
            sm={12}
            md={summaryCount >= 2 ? 24 : 12}
            lg={summaryCount >= 2 ? 12 : 6}
            xl={summaryCount >= 2 ? 12 : 6}
          >
            Statistical Mode:{" "}
            {(parseFloat(tripSummary?.statisticalSpeedMode) || parseFloat(tripSummary?.statisticalSpeedMode) === 0)  ? (
              <>
                <span className="ml025 bold">
                  {parseFloat(tripSummary?.statisticalSpeedMode)?.toFixed(2)}
                </span>
                <span className="ml025">{UNITS.KM_PER_HR}</span>
              </>
            ) : (
              <span className="disabled ml025">NA</span>
            )}
          </Col>
          <Col
            xs={24}
            sm={24}
            md={summaryCount >= 2 ? 24 : 12}
            lg={summaryCount >= 2 ? 24 : 6}
            xl={summaryCount >= 2 ? 24 : 6}
          >
            Top Value:
            {(parseFloat(tripSummary?.topSpeed) || parseFloat(tripSummary?.topSpeed) === 0) ? (
              <>
                <span className="ml025 bold">
                  {parseFloat(tripSummary?.topSpeed)?.toFixed(2)}
                </span>
                <span className="ml025">{UNITS.KM_PER_HR}</span>
              </>
            ) : (
              <span className="disabled ml025">NA</span>
            )}
          </Col>
        </Row>
      </div>
    </>
  );

  return (
    <CardCollapse
      cardClassName="ride-statistic-analytics-card"
      icon={SPEED}
      title={"Speed Analytics"}
      subContent={subContent}
    >
      <Row className="pd0">
        {panelList?.speed?.map((panel, index) => (
          <Col key={index} span={24}>
            <PanelsRow
              title={panel.title}
              url={baseUrl}
              histogramPanel={
                chartType?.histogram &&
                TEST_RIDE_CUMULATIVE.PANEL_ID[panel.var_name]["histogram"]
              }
              boxPlotPanel={
                chartType?.boxPlot &&
                TEST_RIDE_CUMULATIVE.PANEL_ID[panel.var_name]["boxPlot"]
              }
              baseFilterObject={baseFilterObject}
              variableKeys={TEST_RIDE_CUMULATIVE.BASE_VARIABLES}
              data={data}
            />
          </Col>
        ))}
      </Row>
    </CardCollapse>
  );
};

export default SpeedAnalytics;
